/**
* map JS
* -----------------------------------------------------------------------------
*
* All the JS for the map component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// VARS that are set in map.php:
// mapLocations - array of objects [{address, city, state, zip, coordinates: {lat, lng}}]
// mapPin - url string of pin image
// mapStyle - url string of mapbox studio style link
// mapKey - string of mapbox api key
( function( app ) {
  const COMPONENT = {
    className: 'map',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( window.innerWidth >= 640 ) {
        $( '.map__map svg path' ).on( 'click', function() {
          const mapURL = $( this ).data( 'url' );
          console.log( mapURL );
          const fullURL = site_info.url + '/locations/elevator-modernization-in-' + mapURL.replace( '_', '-' );
          console.log( fullURL );
          window.location.href = fullURL;
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'map', COMPONENT );
} )( app );
